import React, { useState, useEffect } from "react";
import { Transaction_Profile } from "../../Connections/Transaction";

import "../../Styles/MyBook.css";

const MyBook = ({ close }) => {
    const [showclickButton, setShowclickButton] = useState(false);
    const [bookList, setBookList] = useState([]);
    
    // ===========================================

    useEffect(() => {
        Transaction_Profile.GetMyBook({ CampaignId: 3 })
            .then((res) => {
                if (res[0]) {
                    setBookList(res[2].data);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    // ===========================================

    return (
        <div className="wallet-wrapper">
            <div className="MyBook">
                <div className="MyBook-inside">
                    <div className="MyBook-inside-item1">
                        <div className="MyBook-inside-item1-text">
                            <p className="MyBook-inside-item1-text-p">
                                کتاب های من
                            </p>
                        </div>

                        <div
                            className="MyBook-inside-item1-image"
                            onClick={close}
                        >
                            <img
                                className="MyBook-inside-item1-image-img"
                                src="imgs/Profile/Icon.svg"
                            />
                        </div>
                    </div>

                    <div className="MyBook-inside-item2">
                        {bookList.map((item) => (
                            <div
                                className="MyBook-inside-item2-Book"
                                key={item.id}
                            >
                                <div className="MyBook-inside-item2-Book-top">
                                    <img
                                        className="MyBook-inside-item2-Book-top-img"
                                        src={item.pic}
                                    />
                                </div>
                                <div className="MyBook-inside-item2-Book-bottom">
                                    <div className="MyBook-inside-item2-Book-bottom-right">
                                        <p className="MyBook-inside-item2-Book-bottom-right-numberBook">
                                            {item.title}
                                        </p>
                                        <p className="MyBook-inside-item2-Book-bottom-right-nameBook">
                                            {item.campiagn}
                                        </p>
                                    </div>
                                    <div className="MyBook-inside-item2-Book-bottom-left">
                                        <button
                                            onClick={() =>
                                                setShowclickButton({
                                                    id: item.id,
                                                })
                                            }
                                            className="MyBook-inside-item2-Book-bottom-left-btn"
                                        >
                                            <img src="imgs/Profile/icon-myBook.svg" />
                                        </button>
                                    </div>
                                    {showclickButton.id == item.id ? (
                                        <div className="MyBook-inside-item2-Book-bottom-clickButton">
                                            <div className="MyBook-inside-item2-Book-bottom-clickButton-inside">
                                                <button
                                                    className="MyBook-inside-item2-Book-bottom-clickButton-inside-button"
                                                    onClick={() =>
                                                        setShowclickButton(
                                                            false
                                                        )
                                                    }
                                                >
                                                    <img src="imgs/Profile/icon-myBook.svg" />
                                                </button>
                                                <div className="MyBook-inside-item2-Book-bottom-clickButton-inside-top">
                                                    <img
                                                        className="MyBook-inside-item2-Book-bottom-clickButton-inside-top-img"
                                                        src="imgs/Profile/deleteBook.svg"
                                                    />
                                                    <p className="MyBook-inside-item2-Book-bottom-clickButton-inside-top-text">
                                                        حذف از لیست
                                                    </p>
                                                </div>
                                                <div className="MyBook-inside-item2-Book-bottom-clickButton-inside-bottom">
                                                    <img
                                                        className="MyBook-inside-item2-Book-bottom-clickButton-inside-bottom-img"
                                                        src="imgs/Profile/shareBook.svg"
                                                    />
                                                    <p className="MyBook-inside-item2-Book-bottom-clickButton-inside-bottom-text">
                                                        اشتراک گذاری
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MyBook;
